import { useState } from "react"
import logo from './logo.svg';
import Products from "./product";

export function Food()
{

    const [search,setSerch] = useState('');
    const [data,setData] = useState([]);

    const YOUR_APP_ID = "8aecf864";
    const YOUR_APP_KEY ="b460ca299374805ea2ad4be4f6ea081a";
    const submitHandler = e =>
    {

        e.preventDefault();
        fetch(`https://api.edamam.com/search?q=${search}&app_id=${YOUR_APP_ID}&app_key=${YOUR_APP_KEY}&from=0&to=30&calories=591-722&health=alcohol-free`).then(
            response => response.json()
          ).then(
            data => setData(data.hits)
          )    }
    return(
        <>
         
        <center>
        <h4>
            Food Recipe App
            </h4><br/>
        <form onSubmit={submitHandler}>
            <input type="text" value={search} onChange={(e) => setSerch(e.target.value)}></input><br/><br/>
            <input type="submit" className="btn btn-primary" value="search" ></input>

        </form>
        </center>
        {data.length>=1 ? <Products  data={data}/>:null}

        </>
    )
}